var map = {
	"./main-page-wide-image-1-1920.jpg": 9100,
	"./main-page-wide-image-2-1920.jpg": 3533,
	"./main-page-wide-image-3-1920.jpg": 2590,
	"./main-page-wide-image-4-1920.jpg": 2855,
	"./main-page-wide-image-5-1920.jpg": 7448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7995;